function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import * as actionTypes from './actionTypes';
const initialState = {
    menuOpen: false,
    selectedMenuItem: null,
    agpView: false,
    fetching: [],
    sending: [],
    errors: [],
    windowWidth: 0
};
export default function reducer(state = _object_spread({}, initialState), action) {
    switch(action.type){
        case actionTypes.SET_MENU_OPEN:
            {
                const { menuOpen } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    menuOpen
                });
            }
        case actionTypes.SET_SELECTED_MENU_ITEM:
            {
                const { selectedMenuItem } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    selectedMenuItem
                });
            }
        case actionTypes.SET_AGP_VIEW:
            {
                const { agpView } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    agpView
                });
            }
        case actionTypes.SET_WINDOW_WIDTH:
            {
                const { windowWidth } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    windowWidth
                });
            }
        default:
            {
                return state;
            }
    }
}
